<template>
    <div>
        <div class="flex-page-content flex-container">
            <div class="flex-body body-scroll">
                <div class="container-fluid">
                    <div class="container-centered-m py-4">
                        <h1 class="mb-2">Set up two-step verification</h1>

                        <template v-if="!done">
                            <p>Your account now needs two-step verification. Turn it on below to continue.</p>
                            <security-section :setup-only="true" @enrolled="onEnrolled" />
                        </template>
                        <template v-else>
                            <p data-test="setup-done">Two-step verification is on. Sign in again with your new method to continue.</p>
                            <button type="button" class="btn btn-primary" data-test="sign-in-again" @click.prevent="toLogin">Sign in again</button>
                        </template>

                        <p class="mt-3" v-if="!done">
                            <a href data-test="sign-out" @click.prevent="signOut">Sign out</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SecuritySection from '@/pages/UserAccount/components/SecuritySection'

// Where a setup-only session lands (MFA past its deadline, not yet set up).
// After turning it on the session is still the emailed code's, so the server
// would refuse everything: it is ended at once, and the user signs in again
// with the new method.
export default {
    components: {SecuritySection},
    data() {
        return {
            done: false,
        }
    },
    mounted() {
        // The saved user can be stale (a rollback to "log", a moved deadline)
        this.$store.dispatch('GET_USER').then(() => {
            const user = this.$store.state.user
            const setup = user && user.mfa_setup
            if (!this.done && !(setup && setup.enforced)) {
                this.$router.replace('/')
            }
        }).catch(() => {})
    },
    methods: {
        onEnrolled() {
            this.done = true
            this.$store.dispatch('LOGOUT')
        },
        signOut() {
            this.$store.dispatch('LOGOUT')
            this.toLogin()
        },
        toLogin() {
            this.$router.push({name: 'login'})
        },
    },
}
</script>
